import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import { entityEstadosLaboratorioLoadFailure, entityEstadosLaboratorioLoadRequest, entityEstadosLaboratorioLoadSuccess } from './estados-laboratorio.actions';
import { EntityEstadoLaboratorioService } from './estados-laboratorio.service';


@Injectable()
export class EntityEstadoLaboratorioEffects {
  // load
  loadRequestEntityEstadoLaboratorio = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEstadosLaboratorioLoadRequest),
      mergeMap(() =>
        this.estadosLaboratorioService.getEstadosLaboratorio().pipe(
          map((items) => entityEstadosLaboratorioLoadSuccess({ items })),
          catchError((error) => of(entityEstadosLaboratorioLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private estadosLaboratorioService: EntityEstadoLaboratorioService,
  ) {
    this.estadosLaboratorioService.url = environment.apiUrl;
  }
}
